import Vue from 'vue';

export default {
  // 信息回显
  getProjectInfo (params) {
    return Vue.axios.get('/api/v1.0/chanquan/project/echo', {params});
  },

  // 保存项目信息
  saveProjectInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/save', payload);
  },
  // 修改项目信息
  updateProjectInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/update', payload);
  },

  // 保存受让信息
  saveTransfereeInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/saveAssignmentConditionsInfo', payload);
  },
  // 修改受让信息
  updateTransfereeInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/updateAssignmentConditionsInfo', payload);
  },

  // 保存附件信息
  saveAttachmentInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/uploadFile', payload);
  },
  // 修改附件信息
  updateAttachmentInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/updateUploadFile', payload);
  },

  // 保存承诺书信息
  saveCommitmentInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/savePromiseHit', payload);
  },
  // 保存承诺书信息
  submit (projectId) {
    return Vue.axios.get('/api/v1.0/chanquan/project/submit?projectId=' + projectId);
  },
  // 修改承诺书信息
  updateCommitmentInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/updatePromiseHit', payload);
  },
  //  获取项目子类型
  getProjectSubType (projectType) {
    return Vue.axios.get('/api/v1.0/chanquan/project/getProjectSubType/' + projectType);
  },
  //  获取注册位置
  getUserBaseInfo () {
    return Vue.axios.get('/api/v1.0/chanquan/user/getUserBaseInfo');
  },
  // 根据输入内容查询用户信息
  getUserInfoByIdCard (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/user/getUserInfoByIdCard', payload);
  },
  // 根据用户id查询用户信息
  getUserInfoById (userId) {
    return Vue.axios.get('/api/v1.0/chanquan/user/getUserInfoById/' + userId);
  },
  // 根据assetsId查询资产信息
  selectInfoByProjectId (assetsCode) {
    return Vue.axios.post('/api/v1.0/chanquan/assets/selectInfoById', { assetsCode });
  },
  // 发布批量协议
  savebatch (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/batch/uploadProject', payload);
  },
  // 获取我的批量转出项目详情
  getBatchProject (id) {
    return Vue.axios.get('/api/v1.0/chanquan/project/batch/getBatchProject?id=' + id);
  },
  // 发布批量协议上传民主决议
  uploadDemocraticDecisionMaking (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/batch/uploadDemocraticDecisionMaking', payload);
  },
  // 发布批量协议上传民主决议
  uploadLetContract (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/batch/uploadLetContract', payload);
  },
  // 发布批量协议上传民主决议
  uploadOther (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/batch/uploadOthers', payload);
  },
  // 编辑批量协议
  updateBatchProject (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/batch/updateBatchProject', payload);
  },
  // 编辑附件
  editFile (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/batch/editFile', payload);
  },
  // 获取我的批量转出项目详情
  getFile (id) {
    return Vue.axios.get('/api/v1.0/chanquan/project/batch/getFile?id=' + id);
  },
  // 获取我的批量转出项目详情
  updateBatchStatus (id) {
    return Vue.axios.get('/api/v1.0/chanquan/project/batch/updateBatchStatus?id=' + id);
  },
  // 获取资产信息
  getAssetsInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/project/getAssetsInfo', payload);
  }
};
